import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoverInclusionsState {
  coverInclusions?: any; // Replace 'any' with a more specific type if available
}

const initialState: CoverInclusionsState = {
  coverInclusions: undefined,
};

export const coverInclusionsSlice = createSlice({
  name: 'coverInclusions',
  initialState,
  reducers: {
    setCoverInclusions: (state, { payload }: PayloadAction<any>) => {
      state.coverInclusions = payload;
    },
  },
});

export const { setCoverInclusions } = coverInclusionsSlice.actions;
export default coverInclusionsSlice.reducer;
